import { Select, Spin } from 'antd'
import { useRef, useState } from 'react'

export function MultiSelect({
  fetchOptions,
  debounceTimeout = 250,
  charactersLimitToFetch = 1,
  value,
  onChange,
  placeholder,
  ...props
}) {
  const [fetching, setFetching] = useState(false)
  const [options, setOptions] = useState([])
  const [hasInitialFetch, setHasInitialFetch] = useState(false)
  const fetchRef = useRef(0)
  const timeoutRef = useRef(null)
  const selectRef = useRef(null)

  const fetchData = async (searchValue = '') => {
    fetchRef.current += 1
    const fetchId = fetchRef.current
    
    setFetching(true)
    setOptions([]) 

    try {
      const cleanedValue = searchValue.replace(/\s+/g, ' ').trim()
      const newOptions = await fetchOptions(cleanedValue)
      
      if (fetchId !== fetchRef.current) {
        return
      }
      
      setOptions(newOptions)
      if (!searchValue) {
        setHasInitialFetch(true)
      }
    } catch (error) {
      if (fetchId === fetchRef.current) {
        setOptions([])
      }
    } finally {
      if (fetchId === fetchRef.current) {
        setFetching(false)
      }
    }
  }

  const onSearch = searchValue => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = null
    }

    if (searchValue.length < charactersLimitToFetch) {
      setOptions([])
      setHasInitialFetch(false)
      setFetching(false)
      fetchRef.current += 1 
      return
    }

    setOptions([])
    setFetching(true)

    timeoutRef.current = setTimeout(() => {
      fetchData(searchValue)
    }, debounceTimeout)
  }

  const onFocus = () => {
    if (!hasInitialFetch && options.length === 0) {
      fetchData()
    }
  }

  const onBlur = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = null
    }
    setOptions([])
    setHasInitialFetch(false)
    setFetching(false)
  }

  const handleChange = (newValue) => {

    onChange(newValue)
    
 
    if (selectRef.current) {
      selectRef.current.blur()
    }

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = null
    }
    setOptions([])
    setHasInitialFetch(false)
    setFetching(false)
  }

  return (
    <Select
      ref={selectRef}
      labelInValue
      filterOption={false}
      onSearch={onSearch}
      onFocus={onFocus}
      onBlur={onBlur}
      showSearch={true}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      options={options}
      mode="multiple"
      style={{
        width: '100%',
      }}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      {...props}
    />
  )
}